import { underscoreTemplateGrindex } from "@grindex-client/common/js/helpers/underscore-helper";
import DomElementsBase from "@grindex-common/abstracts/DomElementsBase.class";

const SELECTOR_DRAWING_RESULT = ".drawing-results";
const SELECTOR_FACET_CONTAINER = ".facet-container";
const SELECTOR_STYLED_CHECKBOX = ".styledCheckbox";
const SELECTOR_FACET_GROUP_HEADER = ".facet-group-header";
const SELECTOR_CHECKED_CHECKBOXES = ".styledCheckbox.checked";
const SELECTOR_DRAWING_RESULT_TEMPLATE = "#drawing-results-tmpl";
const SELECTOR_DRAWING_FACETS_TEMPLATE = "#drawing-facets-tmpl";
const SELECTOR_CAD_DRAWING_RESULT_TEMPLATE = "#cad-drawing-results-tmp";
const SELECTOR_SMALLDEVICE_TOGGLE_FILTERS = ".js-toggle-filters";
const SELECTOR_SMALLDEVIC_CLOSEPANEL = "a.close-panel";
const SELECTOR_BUTTON_DOWNLOAD_CAD = ".download-cad";
const SELECTOR_DROPDOWN_DOWNLOAD_CAD = "#cad-download-formats-dropdown";
const SELECTOR_CLEAR_FACETS_CONTAINER = ".clear-search-facets-container";
const SELECTOR_CLEAR_FACETS_BUTTON = ".clear-facets-btn";

export default class ProductTechnicalDrawingsDom extends DomElementsBase {
	constructor($module) {
		const selectors = [
			SELECTOR_DRAWING_RESULT,
			SELECTOR_FACET_CONTAINER,
			SELECTOR_STYLED_CHECKBOX,
			SELECTOR_CHECKED_CHECKBOXES,
			SELECTOR_DROPDOWN_DOWNLOAD_CAD,
			SELECTOR_CLEAR_FACETS_CONTAINER,
			SELECTOR_CLEAR_FACETS_BUTTON,
		];

		super($module, selectors);

		this.$drawingResult = this.getElement(SELECTOR_DRAWING_RESULT);
		this.$facetContainer = this.getElement(SELECTOR_FACET_CONTAINER);
		this.$filterSmallDeviceToggle = this.getElement(SELECTOR_SMALLDEVICE_TOGGLE_FILTERS);
	}

	getDrawingResultElement() {
		return this.$drawingResult;
	}

	getFacetContainer() {
		return this.$facetContainer;
	}

	getCheckboxes() {
		return this.getFacetContainer().querySelectorAll("input[type=checkbox]");
	}

	getStyledCheckbox() {
		return this.getElements(SELECTOR_STYLED_CHECKBOX, true);
	}

	getSelectedCheckBoxes() {
		return this.getElements(SELECTOR_CHECKED_CHECKBOXES, true);
	}

	getDrawingResultTemplate() {
		return underscoreTemplateGrindex(this.getElement(SELECTOR_DRAWING_RESULT_TEMPLATE).innerHTML);
	}

	getDrawingFacetTemplate() {
		return underscoreTemplateGrindex(this.getElement(SELECTOR_DRAWING_FACETS_TEMPLATE).innerHTML);
	}

	getGouldsResultTemplate() {
		return underscoreTemplateGrindex(this.getElement(SELECTOR_CAD_DRAWING_RESULT_TEMPLATE).innerHTML);
	}

	getFacetGroupHeader() {
		return this.getElements(SELECTOR_FACET_GROUP_HEADER, true);
	}

	getFilterSmallDeviceToggle() {
		return this.$filterSmallDeviceToggle;
	}

	getSmallDeviceClosePanel() {
		return this.getElement(SELECTOR_SMALLDEVIC_CLOSEPANEL, true);
	}

	getDownloadCadButtons() {
		return this.getElements(SELECTOR_BUTTON_DOWNLOAD_CAD);
	}

	getdownloadCadDropdown() {
		return this.getElement(SELECTOR_DROPDOWN_DOWNLOAD_CAD);
	}

	getFacetValue($element) {
		return $element.querySelector("input").dataset.facetValue;
	}

	getClearFacetsButton() {
		return this.getElement(SELECTOR_CLEAR_FACETS_BUTTON, true);
	}

	getClearFacetsContainerElement() {
		return this.getElement(SELECTOR_CLEAR_FACETS_CONTAINER, true);
	}

	toggleClearFacetsButton(enabled) {
		const $clearFacetsBtn = this.getClearFacetsButton();

		if ($clearFacetsBtn) {
			if (enabled) {
				$clearFacetsBtn.classList.remove("disabled");
			} else {
				$clearFacetsBtn.classList.add("disabled");
			}
		}
	}
}
